import React, { useState, useRef, useEffect } from 'react';
import { Box, TextField, Typography, IconButton, Tooltip } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { handlePinChange } from '../../util/functions/handlePinChange';
import InfoIcon from '@mui/icons-material/Info';
import { useDispatch, useSelector } from 'react-redux';
import { setHelloPayPin, setPIN } from '../../reducers/user/userSlice';
import { RootState } from '../../globalStore/store';

interface Step {
  label: string;
  component: React.ReactNode;
}

const PinStep1: React.FC = () => {
  const [code, setCode] = useState<string[]>(Array(4).fill(''));
  const [showPin, setShowPin] = useState<boolean>(false);
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const dispatch = useDispatch();

useEffect(() => {
  dispatch(setPIN(code.join('')));
}, [code])

  return (
    <Box>
      <Typography>
        Válassz magadnak egy 4-jegyű PIN-kódot, ami elég erős és védi a fiókodat. PIN-kód megadása után a POS-on végzett tranzakciókért te felelsz.
      </Typography>
      <Box sx={{ width: '100%' }}>
        <Typography variant={'caption'}>{"4-jegyű Kód"}</Typography>
        <Box display="flex" justifyContent="space-between" gap={1}>
          {code.map((item, index) => (
            <TextField
              key={index}
              type={showPin ? 'tel' : 'password'}
              variant="outlined"
              value={item}
              onChange={(e) => handlePinChange(index, e.target.value, code, setCode, inputRefs)}
              inputRef={(el) => inputRefs.current[index] = el}
              inputProps={{
                maxLength: 1,
                style: { textAlign: 'center' },
              }}
            />
          ))}
          <IconButton onClick={() => setShowPin(!showPin)}>
            {showPin ? <Visibility />  : <VisibilityOff /> }
          </IconButton>
        </Box>
        <Typography>A pin kód kizárólag számokból állhat.</Typography>
      </Box>
    </Box>
  );
}

const PinStep2: React.FC = () => {
  const helloPayPin = useSelector((state: RootState) => state.user.helloPayPin);
  const dispatch = useDispatch();
  return (
    <Box sx={{position: "relative"}}>
      <Tooltip title={"Ha nem vagy biztos abban, hogy a HelloPay direkt borravaló elérhető nálatok, érdeklődj az üzletvezetőnél vagy a közvetlen felettesednél!"} placement={'top'} sx={{position: 'absolute', top: '-41px', right: 0,
        '& .MuiTooltip-tooltip': {
          backgroundColor: '#F9EAEF',
          color: '#F9EAEF',
          boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
        }
      }}>
        <IconButton>
          <InfoIcon sx={{color: '#874B6D' }} />
          <Typography>Több infó</Typography>
        </IconButton>
      </Tooltip>
      <Typography>
        A kód megadása után a HelloPay terminál és PinkPOS fiókjaidat összekötjük, így elég a PinkPOS-on azonosítanod magad, hogy a neked járó borravalót automatikusan megkapd.
      </Typography>
      <TextField
        fullWidth
        label={'4-16 jegyű HelloPay terminál azonosító'}
        variant={'outlined'}
        type={'tel'}
        value={helloPayPin}
        onChange={(e) => dispatch(setHelloPayPin(e.target.value))}
      />
      <Typography>4-16 jegyű kód, amivel a HelloPay direkt borravaló szolgáltatáshoz azonosítod magad.</Typography>
    </Box>
  );
}

const pinSteps: Step[] = [
  {
    label: 'PIN-kód meghatározása',
    component: <PinStep1 />,
  },
  {
    label: 'HelloPay direkt borravaló',
    component: <PinStep2 />,
  },
];

export default pinSteps;